import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { yesNoOptions } from '../../../utils/mics';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

const SysAppLoggerFilterForm = ({ handleSearch, handleReset, onFormValuesChange }) => {

    const dispatch = useDispatch();

    const filters = useSelector((state) => state.appLogger.filters);
    
    const formik = useFormik({
        initialValues: {
            id: filters?.id || '',
            fileId: filters?.fileId || '',
            fileName: filters?.fileName || '',
            errorTag: filters?.errorTag || '',
            errorTagValue: filters?.errorTagValue || '',
            storeId: filters?.storeId || '',
            errorCode: filters?.errorCode || '',
            errorMsg: filters?.errorMsg || '',
            alertGroup: filters?.alertGroup || '',
            alertDateTime: filters?.alertDateTime || '',
            alertPriority: filters?.alertPriority || '',
            alertProcessed: filters?.alertProcessed || null,
            logText: filters?.logText || '',
            date_from: filters?.date_from || '',
            date_till: filters?.date_till || '',
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };

            dispatch(appActions.SYSAPPLOGGER_SET_FILTERS_REQUEST(values));

            handleSearch(data);
            // Optionally, call onFormValuesChange here as well
            if (onFormValuesChange) {
                onFormValuesChange(data);
            }
        },
       
    });

    const handleClear = () => {
        dispatch(appActions.SYSAPPLOGGER_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const updatedValues = { ...formik.values, [e.target.name]: e.target.value };
            const data = {
                ...updatedValues,
                date_from: updatedValues.date_from ? moment(updatedValues.date_from).format('YYYY-MM-DD') : '',
                date_till: updatedValues.date_till ? moment(updatedValues.date_till).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }
    }

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes

    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">

                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">FileId</label>
                        <InputText id="fileId" name="fileId" type="text" value={formik.values.fileId} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Store Id</label>
                        <InputText id="storeId" name="storeId" type="text" value={formik.values.storeId} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">File Name</label>
                        <InputText id="fileName" name="fileName" type="text" value={formik.values.fileName} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="errorTag">Error Tag</label>
                        <InputText id="errorTag" name="errorTag" type="text" value={formik.values.errorTag} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="errorCode">Error Code</label>
                        <InputText id="errorCode" name="errorCode" type="text" value={formik.values.errorCode} onChange={handleChange} />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Alert Processed</label>
                        <Dropdown filter showClear  value={formik.values.alertProcessed}
                            onChange={handleChange} options={yesNoOptions} 
                            id="alertProcessed" name="alertProcessed" optionLabel="name" optionValue='code' />
                    </div>

                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>
                    
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_till">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from}/>
                    </div>

                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search" />
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined onClick={handleClear} />
                </div>
            </>
        );
    };

    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default SysAppLoggerFilterForm;
